/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Footer_Link_ContactInputs */

const en_home_footer_link_contact = /** @type {(inputs: Home_Footer_Link_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Support`)
};

const fr_home_footer_link_contact = /** @type {(inputs: Home_Footer_Link_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacter le soutien`)
};

/**
* | output |
* | --- |
* | "Contact Support" |
*
* @param {Home_Footer_Link_ContactInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_footer_link_contact = /** @type {((inputs?: Home_Footer_Link_ContactInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Footer_Link_ContactInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_footer_link_contact(inputs)
	return fr_home_footer_link_contact(inputs)
});